import React, { useState, useEffect } from 'react';
import { createColumn, getInfo } from '../../utils/api';
import { toast } from 'sonner';
import { useT } from '../../i18n';

const CalculatedColumnOperation = ({ onSuccess, onCancel }) => {
  const t = useT();
  const [columnName, setColumnName] = useState('');
  const [formula, setFormula] = useState('');
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadColumns = async () => {
      try {
        const result = await getInfo();
        setColumns(result.info.column_names || []);
      } catch (error) {
        toast.error(t('form.loadColumnsFailed'));
      }
    };
    loadColumns();
  }, []);

  const insertColumn = (col) => {
    setFormula(formula + col);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const columnsMap = {};
      columns.forEach(col => {
        columnsMap[col] = col;
      });
      
      const result = await createColumn({
        column_name: columnName,
        formula: formula,
        columns_map: columnsMap
      });
      onSuccess(result);
    } catch (error) {
      toast.error(error.response?.data?.detail || t('calculated.failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="label mb-1">{t('calculated.nameLabel')}</label>
        <input
          type="text"
          value={columnName}
          onChange={(e) => setColumnName(e.target.value)}
          className="input"
          placeholder={t('calculated.namePlaceholder')}
          required
        />
      </div>

      <div>
        <label className="label mb-1">{t('calculated.formulaLabel')}</label>
        <p className="text-xs text-muted-foreground mb-2">
          {t('calculated.formulaHelp')}
        </p>
        <textarea
          value={formula}
          onChange={(e) => setFormula(e.target.value)}
          className="input min-h-[100px]"
          placeholder={t('calculated.formulaPlaceholder')}
          required
        />
      </div>

      <div>
        <label className="label mb-2">{t('calculated.insertColumn')}</label>
        <div className="flex flex-wrap gap-2">
          {columns.map(col => (
            <button
              key={col}
              type="button"
              onClick={() => insertColumn(col)}
              className="btn-secondary text-xs h-8"
            >
              {col}
            </button>
          ))}
        </div>
      </div>

      <div className="card p-4 bg-blue-50 border-blue-200">
        <p className="text-xs text-blue-800">
          <strong>{t('calculated.examplesLabel')}</strong>
          <br />• {t('calculated.example1')}
          <br />• {t('calculated.example2')}
          <br />• {t('calculated.example3')}
        </p>
      </div>

      <div className="flex gap-2 pt-4 border-t">
        <button type="submit" disabled={loading} className="btn-primary flex-1" data-testid="apply-calculated-column">
          {loading ? t('calculated.creating') : t('calculated.apply')}
        </button>
        <button type="button" onClick={onCancel} className="btn-secondary">
          {t('form.cancel')}
        </button>
      </div>
    </form>
  );
};

export default CalculatedColumnOperation;